import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  Card,
  CardContent,
} from '@mui/material';
import { Twitter as TwitterIcon } from '@mui/icons-material';

const Twitter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
        {t('marketing.twitter')}
      </Typography>

      <Card elevation={2}>
        <CardContent sx={{ textAlign: 'center', py: 8 }}>
          <TwitterIcon sx={{ fontSize: 120, color: '#1DA1F2', mb: 3 }} />
          <Typography variant="h3" gutterBottom sx={{ fontWeight: 'bold', color: '#1DA1F2' }}>
            {t('marketing.comingSoon')}
          </Typography>
          <Typography variant="h6" color="text.secondary">
            Twitter (X) marketing features will be available soon
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Twitter;
